export interface EmojiCategory {
  id: string;
  label: string;
  icon: string;
  emojis: string[];
}

const split = (s: string) => s.trim().split(/\s+/);

export const EMOJI_CATEGORIES: EmojiCategory[] = [
  {
    id: 'popular',
    label: 'Частые',
    icon: '⭐',
    emojis: split(`
      🔔 ⏰ ⏳ 📅 🗓️ 📌 📍 ✅ ☑️ ❗ ⚠️ 💡 📝 📋 📞 📧 💬 🎯 🔥 ⭐
      💊 💧 🏃 🧘 😴 🍽️ ☕ 🛒 💰 💳 🧾 🏠 🚗 ✈️ 🎂 🎁 🎉 ❤️ 👶 🐶
    `),
  },
  {
    id: 'work',
    label: 'Дела',
    icon: '💼',
    emojis: split(`
      💼 🗂️ 📁 📂 📊 📈 📉 🗃️ 🗄️ 🖇️ 📎 ✂️ 🖊️ ✏️ 🖍️ 📐 📏 📓 📔 📒
      📕 📗 📘 📙 📚 📖 🔖 🏷️ 💻 🖥️ ⌨️ 🖱️ 🖨️ 📱 ☎️ 📠 📡 🔋 🔌 💾
      💿 📀 🧮 🎓 🏫 🏢 🏦 🧑‍💻 👨‍💼 👩‍💼 🤝 📣 📢 🗳️ 📮 📬 📦 🧰 🔧 🔨
    `),
  },
  {
    id: 'health',
    label: 'Здоровье',
    icon: '💊',
    emojis: split(`
      💊 💉 🩺 🩹 🩼 🦷 🧴 🧼 🪥 🛁 🚿 🧖 💆 💇 🏥 🚑 🌡️ 🧬 🫀 🫁
      🧠 👁️ 🏃 🚶 🧘 🏋️ 🤸 🚴 🏊 ⛹️ 🤾 🧗 🏌️ ⚽ 🏀 🎾 🏐 🥊 🎿 ⛸️
      💪 🥗 🥦 🍎 🥕 🥛 💧 😴 🛌 🌙
    `),
  },
  {
    id: 'food',
    label: 'Еда',
    icon: '🍔',
    emojis: split(`
      🍏 🍎 🍐 🍊 🍋 🍌 🍉 🍇 🍓 🫐 🍒 🍑 🥭 🍍 🥥 🥝 🍅 🥑 🍆 🥔
      🥕 🌽 🌶️ 🥒 🥬 🥦 🧄 🧅 🍄 🥜 🍞 🥐 🥖 🥨 🧀 🥚 🍳 🥞 🧇 🥓
      🍗 🍖 🌭 🍔 🍟 🍕 🥪 🌮 🌯 🥙 🍝 🍜 🍲 🍣 🍱 🥟 🍤 🍚 🍰 🧁
      🍩 🍪 🍫 🍬 🍯 ☕ 🍵 🧃 🥤 🍺 🍷 🥂 🍾 🍽️ 🥄 🍴
    `),
  },
  {
    id: 'people',
    label: 'Люди',
    icon: '😀',
    emojis: split(`
      😀 😃 😄 😁 😆 😅 😂 🤣 😊 😇 🙂 😉 😍 🥰 😘 😋 😎 🤓 🧐 🤔
      🤗 🤩 🥳 😏 😌 😴 🤒 🤕 🤧 😷 🥵 🥶 😱 😤 😡 🤯 😭 😢 🙄 😬
      👋 🤚 ✋ 👌 🤞 ✌️ 👍 👎 👏 🙌 🙏 💪 👀 👶 🧒 👦 👧 🧑 👨 👩
      🧓 👴 👵 👪 👨‍👩‍👧 💑 👫 🧑‍🤝‍🧑 🧑‍🍳 🧑‍🔧 🧑‍🏫 🧑‍⚕️ 🧑‍🎨 🦸 🧙 🎅
    `),
  },
  {
    id: 'nature',
    label: 'Природа',
    icon: '🌿',
    emojis: split(`
      🐶 🐱 🐭 🐹 🐰 🦊 🐻 🐼 🐨 🐯 🦁 🐮 🐷 🐸 🐵 🐔 🐧 🐦 🦆 🦉
      🐴 🦄 🐝 🦋 🐌 🐞 🐢 🐍 🐙 🐠 🐟 🐬 🐳 🐈 🐕 🐇 🦔 🐾 🌵 🎄
      🌲 🌳 🌴 🌱 🌿 ☘️ 🍀 🪴 🍁 🍂 🌷 🌹 🌺 🌸 🌼 🌻 🌞 🌝 🌛 ⭐
      🌟 ✨ ⚡ ☄️ 🔥 🌈 ☀️ ⛅ ☁️ 🌧️ ⛈️ 🌩️ ❄️ ☃️ 🌬️ 💨 🌊 💧 ☔ 🌍
    `),
  },
  {
    id: 'travel',
    label: 'Места',
    icon: '✈️',
    emojis: split(`
      🚗 🚕 🚙 🚌 🚎 🏎️ 🚓 🚑 🚒 🚐 🛻 🚚 🚜 🛵 🏍️ 🚲 🛴 🚨 🚦 ⛽
      🚂 🚆 🚇 🚊 🚉 ✈️ 🛫 🛬 🚁 🚀 🛸 ⛵ 🚤 🛳️ ⚓ 🗺️ 🧭 🏔️ ⛰️ 🏕️
      🏖️ 🏝️ 🏞️ 🏟️ 🏛️ 🏗️ 🏘️ 🏠 🏡 🏢 🏣 🏥 🏦 🏨 🏪 🏫 🏬 🏭 🏰 💒
      🗼 🗽 ⛪ 🕌 ⛩️ ⛲ ⛺ 🌁 🌃 🏙️ 🌄 🌅 🌆 🌇 🌉 🎠 🎡 🎢 🧳 🛎️
    `),
  },
  {
    id: 'objects',
    label: 'Предметы',
    icon: '💡',
    emojis: split(`
      ⌚ 📷 📸 📹 🎥 📺 📻 🎙️ ⏱️ ⏲️ ⏰ 🕰️ ⌛ ⏳ 💡 🔦 🕯️ 🧯 💸 💵
      💴 💶 💷 🪙 💰 💳 💎 ⚖️ 🔧 🪛 🔩 ⚙️ 🧱 🧲 🔫 💣 🔪 🗡️ 🛡️ 🔮
      🧿 💈 🔭 🔬 🧹 🧺 🧻 🚽 🚰 🧽 🪣 🛏️ 🛋️ 🪑 🚪 🪟 🧸 🖼️ 🛍️ 🛒
      🎁 🎈 🎀 🪄 🎊 🎉 🎎 🏮 ✉️ 📩 📨 📧 💌 📥 📤 📦 🔑 🗝️ 🔒 🔓
    `),
  },
  {
    id: 'activities',
    label: 'Досуг',
    icon: '🎮',
    emojis: split(`
      🎮 🕹️ 🎲 ♟️ 🧩 🎯 🎳 🎰 🎨 🖌️ 🧵 🧶 🎭 🎬 🎤 🎧 🎼 🎹 🥁 🎷
      🎺 🎸 🪕 🎻 🎟️ 🎫 🏆 🥇 🥈 🥉 🏅 🎖️ 🏵️ 🎗️ 🎃 🎄 🎆 🎇 🧨 🎑
      📚 📖 🎣 🤿 🛶 🏄 🏇 🧗 🪁 🛹
    `),
  },
  {
    id: 'symbols',
    label: 'Символы',
    icon: '❤️',
    emojis: split(`
      ❤️ 🧡 💛 💚 💙 💜 🖤 🤍 🤎 💔 ❣️ 💕 💞 💓 💗 💖 💘 💝 ☮️ ✝️
      ☯️ ♈ ♉ ♊ ♋ ♌ ♍ ♎ ♏ ♐ ♑ ♒ ♓ ⛎ 🔆 🔅 ⚜️ 🔱 📛 🔰
      ⭕ ✅ ☑️ ✔️ ❌ ❎ ➕ ➖ ➗ ✖️ ♾️ ‼️ ⁉️ ❓ ❔ ❕ ❗ 〰️ 💱 💲
      ⚠️ 🚸 ⛔ 🚫 🔞 ☢️ ☣️ ⬆️ ↗️ ➡️ ↘️ ⬇️ ↙️ ⬅️ ↖️ ↕️ ↔️ 🔄 🔃 🔁
      🔂 ▶️ ⏸️ ⏹️ ⏺️ ⏭️ ⏮️ ⏩ ⏪ 🔀 🆕 🆓 🆗 🆙 🆒 🔴 🟠 🟡 🟢 🔵
      🟣 🟤 ⚫ ⚪ 🟥 🟧 🟨 🟩 🟦 🟪 🟫 ⬛ ⬜ 🔶 🔷 🔸 🔹 🔺 🔻 💠
    `),
  },
];

export const PRESET_COLORS = [
  '#6366f1', '#8b5cf6', '#ec4899', '#ef4444', '#f97316', '#f59e0b',
  '#eab308', '#84cc16', '#22c55e', '#14b8a6', '#06b6d4', '#3b82f6',
  '#64748b', '#78716c',
];
